import { AxiosError } from "axios";
import {Formik, useFormik} from "formik";
import { useContext, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { AppContext } from "../../appContext/AppContext";
import { CODE_SUCCESS } from "../../utils/Constant";
import {PLAN_MODEL_JSON} from "../constants/buildPlans";
import { createPlan, getPlanById, updatePlan } from "../services/PlanServices";
import { convertToPlanRequest, convertToPlanRes } from "../utils/PlanUtils";
import {generateInitValues, generateValidationSchema} from "../../utils/AppFunction";
import GenerateFormComponent from "../../component/generate-form/GenerateFormHTMLNoValid";
import {useBuildPlanContext} from "../constants/context";

type Props = {
  show: boolean;
  onCloseDialog: () => void;
  formJson?: any;
};

const BuildPlanModal = (props: Props) => {
  const {show, onCloseDialog, formJson} = props;
  const {setIsLoading} = useContext(AppContext);
  const {plan, setPlan} = useBuildPlanContext();
  const formCode = formJson?.name || PLAN_MODEL_JSON.BUILD_PLAN;

  const formik = useFormik({
    initialValues: generateInitValues(formJson),
    validationSchema: Yup.object({}),
    onSubmit: (values: any) => {
      handleSavePlan(convertToPlanRequest(values));
    },
  });
  const handleGetPlanById = async (id: string) => {
    setIsLoading(true);
    try {
      const { data } = await getPlanById(id);
      if (data?.code === CODE_SUCCESS) {
        setPlan(data?.data);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (plan?.id) {
      handleGetPlanById(plan?.id).then(r => r);
    } else {
      formik.resetForm();
    }
  }, [plan?.id]);

  const handleSavePlan = async (values: any) => {
    setIsLoading(true);
    try {
      const payload = values[formCode]
      const { data } = payload?.id
        ? await updatePlan(payload, payload?.id)
        : await createPlan(payload);
      if (data?.code === CODE_SUCCESS) {
        toast.success(payload?.id ? "Cập nhật thành công" : "Thêm thành công");
        onCloseDialog();
      } else {
        toast.warning("Có lỗi xảy ra, vui lòng thử lại!");
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      toast.error(
        axiosError.response?.data?.message ?? "Có lỗi xảy ra, vui lòng thử lại!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} centered onHide={onCloseDialog}>
      <Formik
        enableReinitialize
        initialValues={{ [formCode]: plan }}
        validationSchema={generateValidationSchema(formJson, formCode)}
        onSubmit={handleSavePlan}
      >
        {({
            values,
            touched,
            errors,
            setValues,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              {plan?.id ? "Cập nhật kế hoạch" : "Thêm kế hoạch"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="spaces px-10">
              <GenerateFormComponent
                listFieldAuto={formJson}
                itemEdit={plan}
                handleChange={handleChange}
                setValues={setValues}
                values={values}
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
                modelID={formJson?.name}
                customFieldReadOnly={{
                  classId: plan?.id,
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button className="btn-fill spaces min-w-60" type="submit">
              Lưu
            </Button>
            <Button
              className="btn-outline spaces min-w-60"
              onClick={onCloseDialog}
            >
              Hủy
            </Button>
          </Modal.Footer>
        </Form>

      )}
    </Formik>

    </Modal>
  );
};

export default BuildPlanModal;
